<script setup>
import { useGlobalStore } from '@stores/global'
import MobileMenuItem from '@components/global/MobileMenuItem.vue'

defineProps({
	items: {
		type: Array,
		required: true,
	},
})

const global = useGlobalStore()

const closeMobile = () => {
	global.toggleMobile(false)
}
</script>

<template>
	<div class="fixed left-0 top-16 z-9998 flex h-[calc(100dvh-60px)] w-full justify-end lg:hidden" v-if="global.mobile">
		<div class="inner z-9999 flex h-full w-4/5 flex-col border-t border-neutral-700 bg-snk-light-600 p-6 text-sm font-bold uppercase" v-click-outside="closeMobile">
			<ul class="flex w-full grow flex-col gap-1.5 overflow-y-auto">
				<MobileMenuItem v-for="(item, i) in items" :key="item.label + i" :item="item" :depth="0" />
			</ul>
		</div>
		<div class="overlay absolute left-0 top-0 z-9997 h-full w-full bg-neutral-900/50" />
	</div>
</template>
